import { render, staticRenderFns } from "./TrainingSteps.vue?vue&type=template&id=32b95500&"
import script from "./TrainingSteps.vue?vue&type=script&lang=js&"
export * from "./TrainingSteps.vue?vue&type=script&lang=js&"
import style0 from "./TrainingSteps.vue?vue&type=style&index=0&id=32b95500&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports